import { gateway } from "../../../../gateway";

export const postProvider = async ({ token, data }) => {
  try {
    const res = await gateway.post(
      `/providers/`,
      data,
      {
        headers: {
          Authorization: `${token}`,
        },
      }
    );
    return res.data;
  } catch (error) {
    throw error;
  }
};
